import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { TokenService } from '../services/token.service';
import { BACKEND_SYSTEM, ConfigService } from 'libs/core/configuration/src/lib/config.service';

@Injectable()
export class Interceptor implements HttpInterceptor {

    constructor(private tokenService: TokenService, private configService: ConfigService) {
    }
    intercept(request: HttpRequest<any>, next: HttpHandler): any {
        const token = this.tokenService.getToken();
        if (token && request.url !== this.configService?.configuration?.WebApi?.ServiceURLs.Account_Refresh_Token) {
            request = request.clone({
                setHeaders: {
                    Authorization: 'Bearer ' + token,
                    'content-type': 'application/json'
                }
            });
            if (!request.headers.has('Content-Type')) {
                request = request.clone({
                    setHeaders: {
                        'Accept': 'application/json,text/html,application/xhtml+xml,application/xml;q=0.9,image/png,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9'
                    }
                });
            }
        }

        return next.handle(request).pipe(
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                }
                return event;
            }),
            catchError((error: HttpErrorResponse) => {
                console.log(error);
                if (error instanceof HttpErrorResponse && this.configService.backEndSystem === BACKEND_SYSTEM.SPACEONE) {
                    if (error.status === 401 && !request.url.endsWith('me') && !request.url.endsWith('renew') && !request.url.endsWith('login')) {
                        return this.tokenService.renewTokenAnRetryRequest(request, this.configService?.configuration?.WebApi?.BaseURL);
                    } else {
                        return throwError(error);
                    }
                }
            }));
    }
}